const Timelinelabel = ({ labeltext, color }) => {
  return (
    <div style={{ position: "relative" }}>
      <div style={{
        position: "absolute",
        left: "-35px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        background: "#1a73e8",
        border: "3px solid #fff",
        boxShadow: "0 0 0 2px #1a73e8",
      }} />
      <span style={{
        display: "inline-block",
        background: color ? `var(--${color})` : "#e3f2fd",
        color: "#1565c0",
        fontSize: "0.72rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        padding: "3px 10px",
        borderRadius: "20px",
      }}>
        {labeltext}
      </span>
    </div>
  );
};


export default Timelinelabel;
